import { List } from "immutable";
import { RootState } from "common/reducers";
import { createSelector } from "reselect";
import { currentMeasurement } from "common/selectors/measurement.common.selectors";
import { recordChanged } from "common/helpers/Record";

export const rootKey = "windows";

export const window = (state: RootState, props: any) => state.getIn([rootKey, "byId", props.windowId]);
export const lastSavedWindow = (state: RootState, props: any) =>
  state.getIn([rootKey, "lastSavedById", props.windowId]);

/**
 * Gets the windows for the given ids
 *
 * @param {RootState} state The RootState
 * @param {{}} props The props
 * @returns {List<WindowRecord>} windows
 */
export const windows = (state: RootState, props: any) => {
  return props.windowIds.map((id: number) => window(state, { windowId: id }));
};
/**
 * Gets the last saved windows for the given ids
 *
 * @param {RootState} state The RootState
 * @param {{}} props The props
 * @returns {List<WindowRecord>} lastSavedWindows
 */
export const lastSavedWindows = (state: RootState, props: any) => {
  return props.windowIds.map((id: number) => lastSavedWindow(state, { windowId: id }));
};

/**
 * Gets the windows for the current measurement
 *
 * @param {RootState} state The RootState
 * @param {{}} options NONE
 * @returns {List<WindowRecord>} windows
 */
export const currentMeasurementWindows = createSelector(
  [currentMeasurement, (state: RootState) => state],
  (measurement, state) => {
    return windows(state, { windowIds: measurement?.get("window_ids") || List() });
  },
);

/**
 * Gets the last saved windows for the current measurement
 *
 * @param {RootState} state The RootState
 * @param {{}} options NONE
 * @returns {List<WindowRecord>} lastSavedWindows
 */
export const currentMeasurementLastSavedWindows = createSelector(
  [currentMeasurement, (state: RootState) => state],
  (measurement, state) => {
    return lastSavedWindows(state, { windowIds: measurement?.get("window_ids") || List() });
  },
);

/**
 * Checks if the windows have changed on the current measurement
 *
 * @param {RootState} state RootState
 * @param {{}} options NONE
 * @returns {boolean} True if the windows have changed, false otherwise
 */
export const windowsChanged = (state: RootState): boolean => {
  return recordChanged(currentMeasurementWindows(state), currentMeasurementLastSavedWindows(state));
};
